import { useEffect, useState } from 'react';
import { useStudioStore } from '../../stores/studioStore';
import { Cloud, CloudOff, Loader2, Check } from 'lucide-react';

export default function SaveStatusIndicator() {
  const saveStatus = useStudioStore((s) => s.saveStatus);
  const lastSavedAt = useStudioStore((s) => s.lastSavedAt);
  const saveError = useStudioStore((s) => s.saveError);
  const [showSaved, setShowSaved] = useState(false);
  const [timeAgo, setTimeAgo] = useState('');

  useEffect(() => {
    if (saveStatus === 'saved') {
      setShowSaved(true);
      const timer = setTimeout(() => setShowSaved(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [saveStatus, lastSavedAt]);

  useEffect(() => {
    if (!lastSavedAt) return;

    const updateTimeAgo = () => {
      const seconds = Math.floor((Date.now() - lastSavedAt.getTime()) / 1000);
      if (seconds < 10) setTimeAgo('just now');
      else if (seconds < 60) setTimeAgo(`${seconds}s ago`);
      else if (seconds < 3600) setTimeAgo(`${Math.floor(seconds / 60)}m ago`);
      else setTimeAgo(`${Math.floor(seconds / 3600)}h ago`);
    };

    updateTimeAgo();
    const interval = setInterval(updateTimeAgo, 10000);
    return () => clearInterval(interval);
  }, [lastSavedAt]);

  if (saveStatus === 'idle' && !lastSavedAt) return null;

  return (
    <div className="flex items-center gap-1.5 text-[11px] transition-opacity duration-300">
      {saveStatus === 'saving' && (
        <>
          <Loader2 size={12} className="text-zinc-500 animate-spin" />
          <span className="text-zinc-500">Saving...</span>
        </>
      )}

      {saveStatus === 'saved' && showSaved && (
        <>
          <Check size={12} className="text-emerald-400/80" />
          <span className="text-emerald-400/80">Saved</span>
        </>
      )}

      {saveStatus === 'saved' && !showSaved && lastSavedAt && (
        <>
          <Cloud size={12} className="text-zinc-600" />
          <span className="text-zinc-600">Saved {timeAgo}</span>
        </>
      )}

      {saveStatus === 'error' && (
        <div className="flex items-center gap-1.5" title={saveError || 'Save failed'}>
          <CloudOff size={12} className="text-red-400/70" />
          <span className="text-red-400/70">Save failed</span>
        </div>
      )}
    </div>
  );
}
